import React, { Component } from 'react'
import Typography from 'material-ui/Typography/Typography';
// import PropTypes from 'prop-types'

export default class ReactJsListItem extends Component {
  // static propTypes = {
  //   prop: PropTypes
  // }

  render() {
    return (
      <Typography
        variant="body1"
        component="span"
      >
        I love <a href="https://reactjs.org" alt="React js, user interface javascript library">React</a> for many reasons. It is always improving its API and its community and third party packages are abundant. This helps me to achieve better <a href="https://en.wikipedia.org/wiki/Don%27t_repeat_yourself" alt="Principle of software engineering called: Don't repeat yourself (DRY code)">DRY code (Don't Repeat Yourself)</a>.
      </Typography>
    )
  }
}



// WEBPACK FOOTER //
// ./src/config/custom-components/ReactJsListItem.js